<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'orange'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.edit')"
        :icon="error ? 'mdi-alert' : 'mdi-pencil-box-multiple'"
        @press="press"
    />
</template>

<style scoped>

</style>